import { __decorate, __metadata } from "tslib";
import { LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";
import axios from "axios";
import { checkUrlAbsolute } from "@lvflanders/bar";
const CONFIG_KEY = "lvflanders.bar.ui.chatBot.lvConnect";
var BarChatBotApiClient = class {
	async getConfiguration() {
		const item = window.localStorage.getItem(CONFIG_KEY);
		if (item && item.length) return JSON.parse(item);
		const config = await this.getConfigurationFromBackend();
		window.localStorage.setItem(CONFIG_KEY, JSON.stringify(config));
		return config;
	}
	async getConfigurationFromBackend() {
		const rootUrl = this.defineRootUrl();
		const environmentUrl = `${rootUrl}/settings/environment.json`;
		const chatBotSettingsUrl = `${rootUrl}/settings/bar-chat-bot/bar-chat-bot.${(await axios.get(environmentUrl)).data.barOmgeving.toLowerCase()}.json`;
		return (await axios.get(chatBotSettingsUrl)).data;
	}
	defineRootUrl() {
		const scriptTag = document.querySelector("script[src*=\"@lvflanders/bar-ui\"]");
		if (!scriptTag) return window.location.origin;
		const src = scriptTag.getAttribute("src");
		let url;
		if (checkUrlAbsolute(src)) url = new URL(src);
		else url = new URL(src, window.location.origin);
		if (url.hostname === "localhost") return url.origin;
		return `${url.href.match(/^(https?:\/\/[^/]+)/)[1]}/${url.href.match(/\/([rap]\/baas-static\/web)/)[1]}`;
	}
};
let BarChatComponent = class BarChatComponent extends LitElement {
	constructor() {
		super(...arguments);
		this.firstname = "";
		this.lastname = "";
		this.email = "";
		this.phone = "";
		this.mobile = "";
	}
	async connectedCallback() {
		super.connectedCallback();
		await this.updateComplete;
		try {
			this.lvConnectConfig = await new BarChatBotApiClient().getConfiguration();
			this.renderScript();
		} catch (error) {
			console.log(error);
		}
	}
	disconnectedCallback() {
		super.disconnectedCallback();
		delete window["embedded_svc"];
	}
	renderScript() {
		const script = document.createElement("script");
		script.type = "text/javascript";
		script.src = "https://service.force.com/embeddedservice/5.0/esw.min.js";
		script.onload = this.initEsw.bind(this);
		this.appendChild(script);
	}
	initEsw() {
		if (this.targetElement) embedded_svc.settings.targetElement = this.targetElement;
		embedded_svc.settings.displayHelpButton = true;
		embedded_svc.settings.language = "nl-NL";
		embedded_svc.settings.defaultMinimizedText = "Chat met ons";
		embedded_svc.settings.disabledMinimizedText = "Chat is offline";
		embedded_svc.settings.loadingText = "Laden...";
		embedded_svc.settings.prepopulatedPrechatFields = {
			FirstName: this.firstname,
			LastName: this.lastname,
			SuppliedEmail: this.email,
			SuppliedName: this.fullUsername,
			SuppliedContactNumber__c: this.klantnummer,
			SuppliedCustomerNumber__c: this.voorwie
		};
		embedded_svc.settings.extraPrechatFormDetails = [
			{
				label: "First Name",
				name: "FirstName",
				value: this.firstname
			},
			{
				label: "Voornaam",
				value: this.firstname,
				transcriptFields: ["FirstName__c"]
			},
			{
				label: "Achternaam",
				value: this.lastname,
				transcriptFields: ["LastName__c"]
			},
			{
				label: "E-mail",
				value: this.email,
				transcriptFields: ["Email__c"]
			},
			{
				label: "Telefoonnummer",
				value: this.phone,
				transcriptFields: ["Phone__c"]
			},
			{
				label: "GSM-nummer",
				value: this.mobile,
				transcriptFields: ["Mobile__c"]
			},
			{
				label: "Klantennummer",
				value: this.klantnummer,
				transcriptFields: ["ContactNumber__c"]
			},
			{
				label: "Voorwie",
				value: this.voorwie,
				transcriptFields: ["CustomerNumber__c"]
			}
		];
		embedded_svc.settings.offlineSupportMinimizedText = "Contacteer ons";
		embedded_svc.settings.enabledFeatures = ["LiveAgent"];
		embedded_svc.settings.entryFeature = "LiveAgent";
		embedded_svc.settings.chatbotAvatarImgURL = this.lvConnectConfig.chatbotAvatarImgUrl;
		embedded_svc.settings.avatarImgURL = this.lvConnectConfig.avatarImgUrl;
		embedded_svc.init(this.lvConnectConfig.salesforceUrl, this.lvConnectConfig.chatUrl, "https://service.force.com", this.lvConnectConfig.id, this.lvConnectConfig.name, {
			baseLiveAgentContentURL: this.lvConnectConfig.baseLiveAgentContentUrl,
			deploymentId: this.lvConnectConfig.deploymentId,
			buttonId: this.lvConnectConfig.buttonId,
			baseLiveAgentURL: this.lvConnectConfig.baseLiveAgentUrl,
			eswLiveAgentDevName: this.lvConnectConfig.eswLiveAgentDevName,
			isOfflineSupportEnabled: true
		});
	}
};
__decorate([property(), __metadata("design:type", HTMLElement)], BarChatComponent.prototype, "targetElement", void 0);
__decorate([property(), __metadata("design:type", String)], BarChatComponent.prototype, "fullUsername", void 0);
__decorate([property(), __metadata("design:type", String)], BarChatComponent.prototype, "klantnummer", void 0);
__decorate([property(), __metadata("design:type", String)], BarChatComponent.prototype, "voorwie", void 0);
__decorate([property(), __metadata("design:type", String)], BarChatComponent.prototype, "firstname", void 0);
__decorate([property(), __metadata("design:type", String)], BarChatComponent.prototype, "lastname", void 0);
__decorate([property(), __metadata("design:type", String)], BarChatComponent.prototype, "email", void 0);
__decorate([property(), __metadata("design:type", String)], BarChatComponent.prototype, "phone", void 0);
__decorate([property(), __metadata("design:type", String)], BarChatComponent.prototype, "mobile", void 0);
BarChatComponent = __decorate([customElement("bar-chat-bot")], BarChatComponent);
const BAAS_TOAST_PORT = Symbol("BaasToastPort");
export { BAAS_TOAST_PORT, BarChatComponent };

//# sourceMappingURL=lvflanders-bar-ui.mjs.map